import { Instance, types } from "mobx-state-tree";

import { AccountInfo } from "@azure/msal-browser";

const Account = types.model("account", {
    homeAccountId: types.string,
    tenantId: types.string,
    username: types.string
});

export type AccountInstance = Instance<typeof Account>;

export const AuthSettingStore = types
    .model("authSettingStore", {
        accountCache: types.optional(types.array(Account), []),
        lastLoginUsername: types.maybe(types.string),
        tenantId: types.optional(types.string, "common")
    })
    .views((self) => ({
        get lastLoginUser() {
            return self.accountCache.find((entry) => entry.username === self.lastLoginUsername);
        },
        get noneLoginUsers() {
            return self.accountCache.filter((entry) => entry.username !== self.lastLoginUsername);
        },
        getUserInTenant(tenantId: string) {
            return self.accountCache.find((entry) => entry.tenantId === tenantId);
        },
        getUserWithId(homeAccountId: string) {
            return self.accountCache.find((entry) => entry.homeAccountId === homeAccountId);
        }
    }))
    .actions((self) => ({
        addUser(account: AccountInfo) {
            if (!self.accountCache.some((entry) => entry.homeAccountId === account.homeAccountId)) {
                self.accountCache.push({
                    homeAccountId: account.homeAccountId,
                    tenantId: account.tenantId,
                    username: account.username
                });
            }
        },
        setLastUserName(username: string | undefined | null) {
            if (username) {
                self.lastLoginUsername = username;
            }
        },
        setTenantId(tenantId: string | undefined) {
            self.tenantId = tenantId ?? "common";
        },
        removeUser(username: string) {
            const index = self.accountCache.findIndex((entry) => entry.username === username);
            if (index >= 0) {
                self.accountCache.splice(index, 1);
            }
        }
    }));
